import(/* webpackMode: "eager" */ "/home/chronicleusa/public_html/chronicles-exhibits/src/app/privacy-policy/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/chronicleusa/public_html/chronicles-exhibits/src/components/ui/footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/chronicleusa/public_html/chronicles-exhibits/src/components/ui/header.jsx");
